import request from "@/utils/request";

export function getList(params) {
  return request({
    url: "/CheckOutManagement/GetCheckOutHistoryWithPaging",
    method: "get",
    params
  });
}